import { Component } from "@angular/core";
import { Platform } from "@ionic/angular";
import { NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { environment } from "../environments/environment.prod";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.css"],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private router: Router,
    private zone: NgZone) {
    this.initializeApp();
  }

  /**
   * Determine the platform and apply css on a per platform basis if needed. Adds a css
   * selector to the body tag for that platform and can then be targeted in css.
   */
  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('android')) {
        document.body.classList.add('android-platform');
      }
    });

    // Add components for utilizing deep links.
    // This will allow mobile users to be able to click on
    // links that will open in the native app, not web browser.
    if (environment.production) {
      App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        this.zone.run(() => {
          const domain = environment.host;

          const pathArray = event.url.split(domain);

          const appPath = pathArray.pop();
          if (appPath) {
            this.router.navigateByUrl(appPath);
          }
        });
      });
    }
  }
}
